import { render, staticRenderFns } from "./CategoryTagSelect.vue?vue&type=template&id=28206f68&scoped=true&"
import script from "./CategoryTagSelect.vue?vue&type=script&lang=js&"
export * from "./CategoryTagSelect.vue?vue&type=script&lang=js&"
import style0 from "./CategoryTagSelect.vue?vue&type=style&index=0&id=28206f68&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28206f68",
  null
  
)

export default component.exports